import type { Publication } from '../../lib/types';

interface BookCoverProps {
  publication: Publication;
  containerClassName: string;
  imageClassName: string;
}

export function BookCover({ publication, containerClassName, imageClassName }: BookCoverProps) {
  const image = <img className={imageClassName} src={publication.coverImage} alt={publication.coverAlt} />;

  if (!publication.purchaseUrl) {
    return <div className={containerClassName}>{image}</div>;
  }

  return (
    <a
      className={containerClassName}
      href={publication.purchaseUrl}
      target="_blank"
      rel="noreferrer"
      aria-label={`View ${publication.title} on Amazon`}
    >
      {image}
    </a>
  );
}
